import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom';
import { IInjectedRootStore, RequiredFeatures } from 'stores';

interface IRestrictedRouteProps extends RouteProps {
    requires: RequiredFeatures;
}

@inject('rootStore')
@observer
export class RestrictedRoute extends React.Component<IRestrictedRouteProps> {
    constructor(props: IRestrictedRouteProps) {
        super(props);
        this.state = {
            verified: false,
        };
    }
    public render(): React.ReactElement {
        const rest = _.omit(this.props, 'component');
        return this.isAllowed ? <Route {...rest} render={this.renderComponent} /> : <Redirect to="/" />;
    }
    private readonly renderComponent = (props: RouteComponentProps<any>): React.ReactNode => {
        const Component: React.ComponentType<RouteComponentProps<any>> | undefined = this.props.component;
        if (!_.isNil(Component)) {
            return <Component {...props} />;
        }
        const render = this.props.render;
        if (_.isFunction(render)) {
            return render(props);
        }
        return <></>;
    };
    private get injected(): IInjectedRootStore {
        return this.props as IRestrictedRouteProps & IInjectedRootStore;
    }
    private get isAllowed(): boolean {
        switch (this.props.requires) {
            case 'DEV':
                return this.injected.rootStore.isDev();
            case 'ADMIN':
                return this.injected.rootStore.isAdmin();
            default:
                return true;
        }
    }
}
